import { Injectable, Inject } from '@angular/core';
import { Countries, ICountry, Anthems, IAnthem, IOfficialCommon } from 'countries-data';
import * as _ from 'lodash';

import { COUNTRIES_DATA } from '../tokens/countries';

@Injectable()
export class CountryService {

  constructor(@Inject(COUNTRIES_DATA) private _countriesData: Countries) { }

  getCountryNativeName(a2: string): string {
    const values: IOfficialCommon[] = _.values(this.getCountryObjByA2(a2).name.native);
    if (values.length > 0) {
        return values[0].common;
    }

    return '';
  }

  getCountryCommonName(a2: string): string {
    return this.getCountryObjByA2(a2).name.common;
  }

  getCapital(a2: string): string {
    return this.getCountryObjByA2(a2).capital;
  }

  getSubRegion(a2: string): string {
    return this.getCountryObjByA2(a2).geo.subregion;
  }

  getPopulationCount(a2: string): number {
    return this.getCountryObjByA2(a2).population.count;
  }

  getWikiSuffix(a2: string): string {
    return this.getCountryObjByA2(a2).wikiLink;
  }

  getCountryNames(): string[] {
    return _.values(this._countriesData).map(c => c.name).map(c => c.common).sort();
  }

  getCountryObjByA2(a2: string): ICountry {
    return this._countriesData[a2.toUpperCase()];
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/services/country.ts